import React from "react";
import { AiOutlineLoading } from "react-icons/ai";

interface CircularProgressProps {
  size?: number;
  color?: string;
  className?: string;
}

const Spinner: React.FC<CircularProgressProps> = ({
  size = 24,
  color = "text-blue-500",
  className = "",
}) => {
  return (
    <AiOutlineLoading
      className={`animate-spin ${color} ${className}`}
      size={size}
      aria-label="Loading"
    />
  );
};

export default Spinner;
